export const queryKey = {
  getAppRoleList: "getAppRoleList",
  getAppRole: "getAppRole",
  getAssignRoleList: "getAssignRoleList",
  getAssignRole: "getAssignRole",
  getUserRoles: "getUserRoles",
  getUserList: "getUserList",
  getUser: "getUser",
  getUserStats: "getUserStats",
};

export const USER_STATUS = {
  active: 0,
  inactive: 1,
};

export enum Team {
  INTERNAL_SALES = 1,
  CREDIT_CONTROL_TEAM = 2,
  CUSTOMER_SERVICE_TEAM = 3,
  REGIONAL_SALES_TEAM = 4,
  MANAGEMENT = 5,
  ANALYTICS = 6,
  TRADE_COUNTER = 7,
  DEPOT_OPERATIONS = 8,
}

export const TEAM_OPTIONS = [
  { label: "Internal Sales Team", value: 1 },
  { label: "Credit Control Team", value: 2 },
  { label: "Customer Service Team", value: 3 },
  { label: "Regional Sales Team", value: 4 },
  { label: "Management", value: 5 },
  { label: "Analytics", value: 6 },
  { label: "Trade Counter", value: 7 },
  { label: "Depot Operations", value: 8 },
];